const cities = [
  {
    name: 'Indianapolis',
    desc: 'Metro hub — families, professionals & seniors covered',
    pop: '880K+',
    href: '/life-insurance-indianapolis',
    icon: 'ri-building-4-line',
  },
  {
    name: 'Carmel',
    desc: "Indiana's fastest-growing suburb — great rates for young families",
    pop: '110K+',
    href: '/carmel-life-insurance',
    icon: 'ri-home-heart-line',
  },
  {
    name: 'Fishers',
    desc: 'Top-ranked city in Indiana — competitive term life rates',
    pop: '108K+',
    href: '/fishers-life-insurance',
    icon: 'ri-community-line',
  },
  {
    name: 'Noblesville',
    desc: 'Growing Hamilton County families trust us for mortgage protection',
    pop: '75K+',
    href: '/life-insurance-noblesville',
    icon: 'ri-map-pin-2-line',
  },
  {
    name: 'Greenwood',
    desc: 'South side Indianapolis families — final expense & term life specialists',
    pop: '65K+',
    href: '/service-areas/greenwood',
    icon: 'ri-leaf-line',
  },
  {
    name: 'Westfield',
    desc: 'Rapidly expanding — whole life & IUL for new homeowners',
    pop: '55K+',
    href: '/service-areas/westfield',
    icon: 'ri-sun-line',
  },
];

const moreAreas = ['Zionsville', 'Avon', 'Brownsburg', 'Fort Wayne', 'Bloomington', 'Kokomo', 'Muncie', 'Terre Haute'];

export default function LocalCoverageSection() {
  return (
    <section className="py-16 md:py-24 bg-[#F9F5F1]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#D97642]/15 text-[#C26638] text-[11px] font-bold uppercase tracking-widest rounded-full mb-4 border border-[#D97642]/25">
              <i className="ri-map-pin-fill text-[12px]"></i>
              Central Indiana Coverage
            </span>
            <h2 className="text-[28px] md:text-[36px] font-bold text-[#1A3A52] leading-[1.2] mb-3">
              Your Neighbor in Indianapolis,<br className="hidden md:block" /> Carmel, Fishers &amp; Noblesville
            </h2>
            <p className="text-[15px] md:text-[16px] text-gray-500 leading-[1.7] max-w-[540px]">
              We&apos;re not a call center — we&apos;re a local Central Indiana agency. Phone &amp; video consultations serving all 92 Indiana counties, with deep roots in Hamilton County communities.
            </p>
          </div>
          <a
            href="/service-areas"
            className="inline-flex items-center gap-2 px-5 py-3 bg-[#1A3A52] text-white text-[14px] font-semibold rounded-lg hover:bg-[#0F2A3F] transition-colors whitespace-nowrap shrink-0 cursor-pointer"
          >
            <i className="ri-map-2-line text-[16px]"></i>
            View All Service Areas
          </a>
        </div>

        {/* City cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {cities.map((city) => (
            <a
              key={city.name}
              href={city.href}
              className="group bg-white rounded-xl p-5 border border-gray-100 hover:border-[#D97642]/40 hover:bg-[#FFF8F4] transition-all cursor-pointer block"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#D97642]/10 rounded-lg group-hover:bg-[#D97642]/20 transition-colors shrink-0">
                  <i className={`${city.icon} text-[#D97642] text-[18px]`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-1">
                    <h3 className="text-[15px] font-bold text-[#1A3A52] group-hover:text-[#D97642] transition-colors">{city.name}</h3>
                    <span className="text-[11px] font-semibold text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full whitespace-nowrap">{city.pop}</span>
                  </div>
                  <p className="text-[13px] text-gray-500 leading-[1.5]">{city.desc}</p>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
                <span className="text-[12px] text-[#D97642] font-semibold group-hover:text-[#C26638] transition-colors flex items-center gap-1">
                  Get a free quote in {city.name}
                  <i className="ri-arrow-right-line text-[13px] group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* More areas strip */}
        <div className="bg-white rounded-xl border border-gray-100 px-5 py-4 flex flex-wrap items-center gap-x-3 gap-y-2">
          <span className="text-[12px] font-bold text-gray-400 uppercase tracking-wider mr-1">Also serving:</span>
          {moreAreas.map((area, i) => (
            <span key={area} className="flex items-center gap-1.5 text-[13px] text-gray-600">
              <i className="ri-map-pin-line text-[#D97642] text-[11px]"></i>
              {area}
              {i < moreAreas.length - 1 && <span className="text-gray-200 ml-1.5">·</span>}
            </span>
          ))}
          <a href="/service-areas" className="text-[13px] text-[#D97642] font-semibold hover:text-[#C26638] transition-colors ml-1 whitespace-nowrap cursor-pointer">
            + all 92 Indiana counties →
          </a>
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-6 bg-gradient-to-r from-[#1A3A52] to-[#0F2A3F] rounded-xl px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-[#D97642]/20 rounded-lg shrink-0">
              <i className="ri-phone-fill text-[#D97642] text-[20px]"></i>
            </div>
            <div>
              <p className="text-[14px] font-semibold text-white">Speak with a local agent today</p>
              <p className="text-[12px] text-white/60">Phone &amp; video appointments available Mon–Sat</p>
            </div>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <a
              href="tel:+13176482983"
              className="px-5 py-2.5 bg-[#D97642] text-white text-[14px] font-bold rounded-lg hover:bg-[#C26638] transition-colors whitespace-nowrap cursor-pointer"
            >
              (317) 648-2983
            </a>
            <a
              href="/book-appointment"
              className="px-5 py-2.5 bg-white/10 border border-white/20 text-white text-[14px] font-semibold rounded-lg hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Online
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
